import React from 'react';

import { NewPromptForm } from '../../../components/NewPromptForm';
import { InfoBlock } from '../../../components/UI';

import { PromptDetailsStepProps } from './PromptDetailsStep.types';
import './PromptDetailsStep.scss';

export const PromptDetailsStep: React.FC<PromptDetailsStepProps> = ({
    promptText,
    promptTitle,
    promptProblem,
    selectedCategories,
    validationErrors,
    onPromptTextChange,
    onPromptTitleChange,
    onPromptProblemChange,
    onChangeCategories,
}: PromptDetailsStepProps) => {
    return (
        <>
            <InfoBlock text="Промпт будет опубликован в общем каталоге и станет доступен всем" />
            <NewPromptForm
                promptText={promptText}
                promptTitle={promptTitle}
                promptProblem={promptProblem}
                selectedCategories={selectedCategories}
                validationErrors={validationErrors}
                onPromptTextChange={onPromptTextChange}
                onPromptTitleChange={onPromptTitleChange}
                onPromptProblemChange={onPromptProblemChange}
                onChangeCategories={onChangeCategories}
            />
        </>
    );
};
